
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  grid = {};
  rows = 100;
  url = "/api/offer/data/grid?_search=true&rows=" + this.rows;
  showFilter = true;

  userFor = ["Booking", "Trip", "App", "Vehicle", "Driver"];
  ratings = ["1", "2", "3", "4", "5"];
  vehicleNo = "";
  couponCode = "";
  name = "";
  validFrom = "";
  menu1 = false;
  filterUrl = "";
  country = "";
  offer = "";
  tariff = "";
  city = "";
  zone = "";
  page = 1;
  offerType = [
    {
      name: "Bank Offer",
      value: "BANK_OFFER",
    },
    {
      name: "Corp Offer",
      value: "CORP_OFFER",
    },
    {
      name: "Partner Offer",
      value: "PARTNER_OFFER",
    },
  ];
  tariffType = [
    {
      name: "DISPOSAL",
      value: "DISPOSAL",
    },
    {
      name: "TRANSFER",
      value: "TRANSFER",
    },
    {
      name: "FIXED ROUTE",
      value: "FIXED_ROUTE",
    },
    {
      name: "PACKAGE",
      value: "PACKAGE",
    },
    {
      name: "SIGHTSEEING",
      value: "SIGHTSEEING",
    },
    {
      name: "POINT TO POINT",
      value: "POINT_TO_POINT",
    },
    {
      name: "OUTSTATION",
      value: "OUTSTATION",
    },
  ];

  get loading() {
    return common.loading;
  }

  async mounted() {
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.couponCode = "";
    this.name = "";
    this.offer = "";
    this.validFrom = "";
    this.tariff = "";
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";

    if (this.couponCode) this.filterUrl += "&couponCode=" + this.couponCode;
    if (this.validFrom) this.filterUrl += "&validFrom=" + this.validFrom;
    if (this.name) this.filterUrl += "&title=" + this.name;
    if (this.tariff) this.filterUrl += "&tariffType=" + this.tariff;
    if (this.offer) this.filterUrl += "&offerType=" + this.offer;
    common.setLoading(true);
    await this.showPage(1);
  }
  async deleteOffer(offer) {
    common.setLoading(true);
    try {
      await doGet("/api/offer/" + offer._id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
}
